import React, { useState, useEffect } from "react"
import { useAuth } from "../../contexts/AuthContext"
import { useHistory } from "react-router-dom"
import { UploadOutlined } from '@ant-design/icons'
import { createFakePosts, getRandomPosts, getUserDocument } from '../../firebase';
import LoadingCards from "../Loading/loadingCards";
import "./dashboard.css"
import NavBar from '../NavBar/navbar'
import CardRow from "./CardRow";
import { Button, Drawer, message } from "antd";
import { UserForm } from "./uploadForm";


export default function Dashboard() {
  const [error, setError] = useState("")
  const { currentUser, logout } = useAuth() 
  const[open, setOpen] = useState(false)
  const[admin, setAdmin] = useState(false)
  const[name, setName] = useState()
  const history = useHistory()
  const[loading, setLoading] = useState(true)
  const[data, setData] = useState()
  const [messageApi, contextHolder] = message.useMessage();

  const getData = async () => {
   const posts = (await getRandomPosts())
   const user = await getUserDocument()
   setAdmin(user.admin)
   setName(user.firstName + " " + user.lastName)
   setData(posts)
   console.log(posts)
   setLoading(false)
   getUserDocument()
  }

  const success = () => {
    messageApi.open({
      type: 'success',
      content: 'Your post was successfully uploaded.',
    });
  };

  const closeDrawer = () => {
    setOpen(false)
    success()
  }

  useEffect(() => {
    getData()
    // for(let i = 0; i < 10; i++){
    //   createFakePosts()
    // }
  }, [])

  async function handleLogout() {
    setError("")

    try {
      await logout()
      history.push("/login")
    } catch {
      setError("Failed to log out")
    }
  }

if(loading) {
  return (
    <div>
      <LoadingCards />
    </div>
  )
}
else {
  return (
    <div>
      <NavBar />
      {contextHolder}
      <div style={ { width: '15%', justifyContent: 'center', alignItems: 'center', marginLeft: '42.5%' }}>
      <Button type="primary" style={{ marginTop: '10px', marginBottom: '10px', backgroundColor: '#4AAA1A' }} onClick={() => { setOpen(true) }} block>
        Create Cat Post
      </Button>
      </div>
      <Drawer title={'Post Cat Picture'} placement="right" onClose={() => { setOpen(false) }} open={open} size="large">
        <UserForm closeDrawer={closeDrawer} name={name}/>
      </Drawer>
      <CardRow data={data} admin={admin}/>
    </div>
  )
}


}
